module.exports = __webpack_public_path__ + "img/vacuum-robot.4d0e88ff.svg";